const signInKeys = {
  all: ['SIGN_IN'],
  defaultUserInfo: () => [...signInKeys.all, 'USER_INFO'],
  userInfo: ({ userId }) => [...signInKeys.defaultUserInfo(), userId],
};

export default signInKeys;
